import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ExecutingTask } from '../shared/spinner-full-page/executing-task.model';

@Injectable({
  providedIn: 'root',
})
export class ExecutingTaskMonitorService {
  public refreshSpinnerTable: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  public showFullPageSpinner: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);

  public executingTasks: ExecutingTask[] = [];

  constructor() {}
}
